import React, {
  createContext,
  useEffect,
  useReducer,
  useCallback,
} from "react";
import externalProjectsReducer from "./externalProjectsReducer";
import axios from "axios";
import { searchContents } from "../services/api/contents/contents.api";
import { EXTERNAL_PROJECTS_TAB_TYPES } from "../shared/constants/externalProjectsTabs";

const initialContext = {
  currentTerm: "",
  currentTypeSearch: {
    filterType: "",
    filterValue: "",
  },
  completePagingInfo: "",
  currentPagingInfo: "",
  externalProjectsList: {
    loading: true,
    result: [],
  },
};

const ExternalProjects = createContext("");

const ExternalProjectsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(externalProjectsReducer, initialContext);

  const setLoading = (bool) =>
    dispatch({ payload: bool, key: "loading", action: "loading" });

  const setCurrentTerm = (string) =>
    dispatch({ payload: string, action: "currentTerm" });

  const setCurrentTypeSearch = useCallback(({ filterType, filterValue }) => {
    dispatch({
      payload: { filterType, filterValue },
      key: "currentTypeSearch",
      action: "filter",
    });
  }, []);

  const setCurrentTypeSearchType = (type) =>
    dispatch({
      payload: type,
      key: "currentTypeSearch",
      action: "filterType",
    });

  const setCurrentTypeSearchPage = (page) =>
    dispatch({
      payload: page,
      key: "filter",
      action: "pageFilter",
    });

  const setClearCompletePagingInfo = useCallback(
    () =>
      dispatch({
        payload: "",
        action: "clearCompletePagingInfo",
      }),
    []
  );

  const { filterType, filterValue } = state.currentTypeSearch;

  const getExternalProjects = useCallback(() => {
    const source = axios.CancelToken.source();

    setLoading(true);
    setCurrentTerm(filterValue?.term || "");

    searchContents(
      {
        Title: filterValue?.term,
        Types: EXTERNAL_PROJECTS_TAB_TYPES[filterType],
        CreationModes: ["External"],
        PageSize: filterValue?.Limit,
        PageNumber: filterValue?.pageNumber,
      },
      { cancelToken: source.token }
    )
      .then((response) => {
        setLoading(false);
        dispatch({
          payload: response,
          key: "list",
          action: "list",
          isAllTypes: filterType === "Todos",
        });
      })
      .catch((error) => {
        if (!axios.isCancel(error)) setLoading(false);
      });

    return () => source.cancel();
  }, [filterType, filterValue]);

  useEffect(() => {
    if (filterType === "") return undefined;
    return getExternalProjects();
  }, [filterType, getExternalProjects]);

  return (
    <ExternalProjects.Provider
      value={{
        ...state,
        setCurrentTerm,
        setCurrentTypeSearch,
        setCurrentTypeSearchType,
        setCurrentTypeSearchPage,
        setClearCompletePagingInfo,
      }}
    >
      {children}
    </ExternalProjects.Provider>
  );
};

export { ExternalProjects as default, ExternalProjectsProvider };
